import axios from "axios";
import apiurl from "../apiendpoint/apiendpoint";
import { gettoken } from "../token/token";
import { decryptData } from "../encryption";

export const apigetallHomeTestseries = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/test-series/getHomeTestseries`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetHomeTestseriesDetails = async (slug) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/test-series/getHomeTestseriesDetails`,{params:{slug: slug },headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetHomeTestData = async (slug) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/test-series/getHomemainTestData`,{params:{slug: slug },headers: { "Authorization": `Bearer ${token}` }});
        if (res.data.encrypted && res.data.data) {
            const decryptedData = decryptData(res.data.data);
            return { resdata: decryptedData };
        }
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apiSubmitTestResult = async (testData) => {
    try {
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/test-series/submitTestResult`, testData, {
            headers: { "Authorization": `Bearer ${token}` }
        });
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const getTestResult = async (attemptId) => {
  try {
    const token = gettoken();
    const response = await axios.get(`${apiurl()}/test-series/getTestResult`, {params: {attempt_id: attemptId},headers: { "Authorization": `Bearer ${token}` }});
    return response.data;
  } catch (error) {
    console.error('Error fetching test result:', error);
    throw error;
  }
};

export const getUserTestAttempts = async (userId, testSeriesSlug) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/test-series/getUserTestAttempts`, {
            params: { user_id: userId, test_series_slug: testSeriesSlug },
            headers: { "Authorization": `Bearer ${token}` }
        });
        return res.data;
    } catch (err) {
        console.log(err);
        return { success: false, attempts: [] };
    }
};

// payment

export const createOrder = async (testSeriesSlug, userId,userDetails) => {
    try {
        const token = gettoken();
        const response = await axios.post(`${apiurl()}/test-series/create`, {test_series_slug: testSeriesSlug,user_id: userId,user_name: userDetails.user_name,
                user_email: userDetails.user_email,
                user_type: userDetails.user_type },{headers: { "Authorization": `Bearer ${token}`}});
        return response.data;
    } catch (error) {
        console.error('Create order error:', error);
        throw error.response?.data || error;
    }
};

export const verifyPayment = async (paymentData) => {
    try {
        const token = gettoken();
        const response = await axios.post(`${apiurl()}/test-series/verify`, paymentData,{headers: { "Authorization": `Bearer ${token}`}});
        return response.data;
    } catch (error) {
        console.error('Verify payment error:', error);
        throw error.response?.data || error;
    }
};

export const checkPurchaseStatus = async (userId, testSeriesSlug) => {
    try {
        const token = gettoken();
        const response = await axios.get(`${apiurl()}/test-series/check/${userId}/${testSeriesSlug}`,{headers: { "Authorization": `Bearer ${token}`}});
        return response.data;
    } catch (error) {
        console.error('Check purchase status error:', error);
        throw error.response?.data || error;
    }
};

export const getUserOrders = async (userId) => {
    try {
        const token = gettoken();
        const response = await axios.get(`${apiurl()}/test-series/user/${userId}`,{headers: { "Authorization": `Bearer ${token}`}});
        return response.data;
    } catch (error) {
        console.error('Get user orders error:', error);
        throw error.response?.data || error;
    }
};

 export const apiTestseriesdownloadPDF = async(datas)=>{
    var res = await axios.post(`${apiurl()}/test-series/downloadTestseriesPDF`,{razorpay_order_id:datas},{ responseType:'blob', headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
 }